import Joi from "joi";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import Tooltip from "rc-tooltip";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Form from "../../common/form.jsx";
import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel.jsx";

import { saveLabel } from "../../services/labels";
import auth from "./../../services/authservice";
import { getLabel } from "./../../services/labels";
import withRouter from "./../../common/withRouter.jsx";
import { data } from "@tensorflow/tfjs";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Handle = Slider.Handle;

class Label extends Form {
  constructor(props) {
    super(props);

    var maxYesterday = "";
    var minYesterday = DateTime.moment().subtract(1, "day");

    this.minDateRange = (current) => {
      return current.isAfter(minYesterday);
    };
    this.maxDateRange = (current) => {
      return current.isAfter(maxYesterday);
    };
    this.minDateChange = (value) => {
      this.setState({
        maxDateDisabled: false,
      });
      maxYesterday = value;
    };

    this.state = {
      maxDateDisabled: true,
      madeIn: [],
      profiles: [],
      loading: false,
      data: {
        user: "",
        printerName: "",
        name: "",
        description: "",
        labelSize: "",
        fontSize: "12",
        orientation: "",
        SKU: "",
        serial: "",
        madeIn: "",
        barcodeType: "",
        printQuality: "",
        printDensity: "",
        note: "",
        expiredOn: "",
        delivery: "",
        location: "",
        AWB: "",
        country: "",
        copies: 1,
        printedOn: "",
        printUsername: "",
        serviceImage: []
      },
      imageSrc: null,
      selectedFile: null,
      errors: {},
    };

    this.labelSizeOptions = [

      // { value: "100mmx48mm", label: "100mm x 48mm" },
      // { value: "1.5inchx1", label: '1.5"x1' },
      // { value: "1inchx3", label: '1"x3' },
      // { value: "2inchx1", label: '2"x1' },
      // { value: "2-0.25inchx0.5", label: '2-1/4"x1/2' },
      // { value: "1-0.5inchx3-0.5", label: '1-0.5"x3-0.5' },
      // { value: "1-0.2inchx0.85", label: '1-0.2"x0.85' },
      // { value: "1.125inchx1.25", label: '1.125"x1.25' },
      // { value: "1-3/16inchx1", label: '1-3/16"x1' },
      // { value: "1.2inchx0.85", label: '1.2"x0.85' },
      // { value: "1-0.25inchx1", label: '1-0.25"x1' },
      // { value: "1-0.75inchx2-0.75", label: '1-0.75"x2-0.75' },
      // { value: "2.25inchx1.25-1", label: '2.25"x1.25-1' },
      // { value: "2.25inchx1.25", label: '2.25"x1.25' },
      // { value: "2-0.25inchx1-0.25", label: '2-0.25"x1-0.25' },
      // { value: "3inchx1", label: '3"x1' },
      // { value: "3inchx2", label: '3"x2' },
      // { value: "4inchx1", label: '4"x1' },
      // { value: "4inchx2", label: '4"x2' },
      // { value: "4inchx2.5", label: '4"x2.5' },
      // { value: "4inchx3", label: '4"x3' },
      // { value: "4inchx4", label: '4"x4' },
      // { value: "4inchx5", label: '4"x5' },
      // { value: "4inchx6", label: '4"x6' },
      // { value: "4inchx6.5", label: '4"x6.5' },
      // { value: "4inchx8", label: '4"x8' },
      // { value: "4inchx13", label: '4"x13' },
      // { value: "6inchx4", label: '6"x4' },  
      { value: '100x54', label: '3.9" × 2.1" (100 × 54 mm) - Multi-purpose' },
      // Shipping Labels
      { value: '101.6x152.4', label: '4" × 6" (101.6 × 152.4 mm) - Standard Shipping' },
      { value: '101.6x203.2', label: '4" × 8" (101.6 × 203.2 mm) - Large Shipping' },
      { value: '127x203.2', label: '5" × 8" (127 × 203.2 mm) - Extra Large Shipping' },

      // Address Labels
      { value: '89x28', label: '3.5" × 1.1" (89 × 28 mm) - Standard Address' },
      { value: '101.6x50.8', label: '4" × 2" (101.6 × 50.8 mm) - Large Address' },
      { value: '89x36', label: '3.5" × 1.4" (89 × 36 mm) - Return Address' },

      // Barcode Labels
      { value: '25.4x12.7', label: '1" × 0.5" (25.4 × 12.7 mm) - Small Barcode' },
      { value: '50.8x25.4', label: '2" × 1" (50.8 × 25.4 mm) - Standard Barcode' },
      { value: '76.2x25.4', label: '3" × 1" (76.2 × 25.4 mm) - Wide Barcode' },
      { value: '101.6x50.8', label: '4" × 2" (101.6 × 50.8 mm) - Large Barcode' },

      // Product Labels
      { value: '38.1x25.4', label: '1.5" × 1" (38.1 × 25.4 mm) - Small Product' },
      { value: '50.8x50.8', label: '2" × 2" (50.8 × 50.8 mm) - Square Product' },
      { value: '76.2x50.8', label: '3" × 2" (76.2 × 50.8 mm) - Standard Product' },
      { value: '101.6x76.2', label: '4" × 3" (101.6 × 76.2 mm) - Large Product' },

      // Multi-purpose Labels
      { value: '25.4x25.4', label: '1" × 1" (25.4 × 25.4 mm) - Square Small' },
      { value: '38.1x12.7', label: '1.5" × 0.5" (38.1 × 12.7 mm) - Name Tag Small' },
      { value: '63.5x38.1', label: '2.5" × 1.5" (63.5 × 38.1 mm) - Name Tag Standard' },
      { value: '89x50.8', label: '3.5" × 2" (89 × 50.8 mm) - Name Tag Large' },

      // Jewelry Tags
      { value: '25.4x19', label: '1" × 0.75" (25.4 × 19 mm) - Small Jewelry Tag' },
      { value: '38.1x25.4', label: '1.5" × 1" (38.1 × 25.4 mm) - Medium Jewelry Tag' },
      { value: '50.8x31.75', label: '2" × 1.25" (50.8 × 31.75 mm) - Large Jewelry Tag' },

      // Wristband Labels
      { value: '254x25.4', label: '10" × 1" (254 × 25.4 mm) - Adult Wristband' },
      { value: '203.2x25.4', label: '8" × 1" (203.2 × 25.4 mm) - Child Wristband' },

      // Asset Tags
      { value: '50.8x19', label: '2" × 0.75" (50.8 × 19 mm) - Small Asset Tag' },
      { value: '63.5x25.4', label: '2.5" × 1" (63.5 × 25.4 mm) - Standard Asset Tag' },
      { value: '76.2x38.1', label: '3" × 1.5" (76.2 × 38.1 mm) - Large Asset Tag' },

      // File Folder Labels
      { value: '89x12.7', label: '3.5" × 0.5" (89 × 12.7 mm) - File Folder Spine' },
      { value: '101.6x38.1', label: '4" × 1.5" (101.6 × 38.1 mm) - File Folder Tab' },

      // CD/DVD Labels
      { value: '120x120', label: '4.7" × 4.7" (120 × 120 mm) - CD/DVD Face' },
      { value: '151x15', label: '5.9" × 0.6" (151 × 15 mm) - CD Spine' },

      // Laboratory Labels
      { value: '25.4x12.7', label: '1" × 0.5" (25.4 × 12.7 mm) - Vial Label' },
      { value: '38.1x19', label: '1.5" × 0.75" (38.1 × 19 mm) - Test Tube Label' },
      { value: '50.8x25.4', label: '2" × 1" (50.8 × 25.4 mm) - Sample Label' },

      // Cable Labels
      { value: '38.1x12.7', label: '1.5" × 0.5" (38.1 × 12.7 mm) - Wire/Cable Label' },
      { value: '50.8x19', label: '2" × 0.75" (50.8 × 19 mm) - Patch Panel Label' },

      // Prescription Labels
      { value: '101.6x50.8', label: '4" × 2" (101.6 × 50.8 mm) - Standard Rx Label' },
      { value: '127x76.2', label: '5" × 3" (127 × 76.2 mm) - Large Rx Label' },

      // Frozen/Cold Storage
      { value: '25.4x25.4', label: '1" × 1" (25.4 × 25.4 mm) - Cryo Label' },
      { value: '38.1x19', label: '1.5" × 0.75" (38.1 × 19 mm) - Freezer Label' },
    ];

    this.barcodeTypeOptions = [
      { value: "UPC-E", label: "UPC-E" },
      { value: "UPC-A", label: "UPC-A" },
      { value: "JAN/EAN8", label: "JAN/EAN8" },
      { value: "JAN/EAN13", label: "JAN/EAN13" },
      { value: "Code39", label: "Code39" },
      { value: "ITF", label: "ITF" },
      { value: "Code128", label: "Code128" },
      { value: "Code93", label: "Code93" },
      { value: "NW-7", label: "NW-7" },
    ];
    this.printQuality = [
      { value: '6dpmm', label: '6 dpmm (152 DPI)' },
      { value: '8dpmm', label: '8 dpmm (203 DPI)' },
      { value: '12dpmm', label: '12 dpmm (300 DPI)' },
      { value: '24dpmm', label: '24 dpmm (600 DPI)' },
      { value: '152dpi', label: '152 DPI' },
      { value: '203dpi', label: '203 DPI' },
      { value: '300dpi', label: '300 DPI' },
      { value: '600dpi', label: '600 DPI' }
    ];
    this.printDensity = [
      { value: '0', label: '0 (Lightest)' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8 (Medium)' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
      { value: '12', label: '12' },
      { value: '13', label: '13' },
      { value: '14', label: '14' },
      { value: '15', label: '15 (Darkest)' },
      { value: '16', label: '16 (Maximum - some models)' },
      { value: '17', label: '17 (Maximum - some models)' },
      { value: '18', label: '18 (Maximum - some models)' },
      { value: '19', label: '19 (Maximum - some models)' },
      { value: '20', label: '20 (Maximum - some models)' },
      { value: '21', label: '21 (Maximum - some models)' },
      { value: '22', label: '22 (Maximum - some models)' },
      { value: '23', label: '23 (Maximum - some models)' },
      { value: '24', label: '24 (Maximum - some models)' },
      { value: '25', label: '25 (Maximum - some models)' },
      { value: '26', label: '26 (Maximum - some models)' },
      { value: '27', label: '27 (Maximum - some models)' },
      { value: '28', label: '28 (Maximum - some models)' },
      { value: '29', label: '29 (Maximum - some models)' },
      { value: '30', label: '30 (Maximum - some models)' }
    ];

    this.handleSlider = (props) => {
      const { value, dragging, index, ...restProps } = props;
      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={value}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      );
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeImgHandler = this.onChangeImgHandler.bind(this);
    this.handleBoolean = this.handleBoolean.bind(this)
  }

  async populatelabelSize() {
    this.labelSizeoptions = this.labelSizeOptions.map((option) => (
      <option key={option.label} value={option.value}>
        {option.label}
      </option>
    ));
  }
  async populatePrintQuality() {
    this.printQualityOptions = this.printQuality.map((option) => (
      <option key={option.label} value={option.value}>
        {option.value}
      </option>
    ));
  }
  async populatePrintDensity() {
    this.printDensityOptions = this.printDensity.map((option) => (
      <option key={option.label} value={option.value}>
        {option.value}
      </option>
    ));
  }

  async populatebarcodeType() {
    this.barcodeTypeoptions = this.barcodeTypeOptions.map((option) => (
      <option key={option.label} value={option.value}>
        {option.value}
      </option>
    ));
  }

  handleBoolean = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];
    const data = { ...this.state.data };
    if (input.value === "true") {
      data[input.name] = true;
    }
    if (input.value === "false") {
      data[input.name] = false;
    }
    this.setState({ data, errors });
  };

  async populateLabel() {
    try {
      const LabelId = this.props.params.id;

      if (LabelId === "new") return;

      const { data: label } = await getLabel(LabelId);

      this.setState({
        data: this.mapToViewModel(label),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/error");
    }
  }

  setCurrentUser() {
    const Id = this.props.params.id;

    if (Id !== "new") return;

    const { _id: currentUser_id } = auth.getProfile();
    const data = { ...this.state.data };
    data.user = currentUser_id;
    this.setState({ data: data });
  }

  async componentDidMount() {
    const LabelId = this.props.params.id;
    if (LabelId === "new") this.setCurrentUser();;
    await this.populatelabelSize();
    await this.populatebarcodeType();
    await this.populateLabel();
    await this.populatePrintDensity();
    await this.populatePrintQuality();
  }

  schema = Joi.object({
    user: Joi.string().optional(),
    name: Joi.string().optional(),
    description: Joi.string().optional(),
    labelSize: Joi.string().optional(),
    fontSize: Joi.string().optional(),
    SKU: Joi.bool().optional(),
    serial: Joi.bool().optional(),
    copies: Joi.number().optional(),
    madeIn: Joi.bool().optional(),
    printUsername: Joi.bool().optional(),
    printerName: Joi.string().optional(),
    printedOn: Joi.bool().optional(),
    orientation: Joi.bool().optional(),
    expiredOn: Joi.bool().optional(),
    barcodeType: Joi.string().optional(),
    note: Joi.bool().optional(),
    AWB: Joi.bool().optional(),
    country: Joi.bool().optional(),
    delivery: Joi.bool().optional(),
    location: Joi.bool().optional(),
    printQuality: Joi.string().optional(),
    printDensity: Joi.string().optional(),
    serviceImage: Joi.array().optional()
  });

  onChangeImgHandler = event => {
    this.setState({ imageSrc: event.target.files[0] });
    console.log(event.target.files[0]);
  }

  doSubmit = async (label) => {
    this.setState({ loading: true });
    try {
      // return console.log(this.state.data);
      await saveLabel(this.state.data);
      this.setState({ loading: false });
      this.props.navigate("/label/labels");
    } catch (ex) {
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        this.setState({ loading: false });
      }
      this.setState({ loading: false });
    }
  };

  mapToViewModel(data) {
    return {
      _id: data._id,
      user: data.user,
      name: data.name,
      description: data.description,
      printerName: data.printerName,
      labelSize: data.labelSize,
      fontSize: data.fontSize,
      orientation: data.orientation,
      SKU: data.SKU,
      serial: data.serial,
      madeIn: data.madeIn[0],
      barcodeType: data.barcodeType,
      copies: data.copies,
      printedOn: data.printedOn,
      expiredOn: data.expiredOn,
      note: data.note,
      AWB: data.AWB,
      country: data.country,
      delivery: data.delivery,
      location: data.location,
      printUsername: data.printUsername,
      printQuality: data.printQuality,
      printDensity: data.printDensity,
      serviceImage: data.serviceImage || []
    };
  }

  render() {
    const { data, errors } = this.state;
    return (
      <React.Fragment>
        <div>
          <h1 className="page-header">
            Add Label <small>Label-configuration-form</small>
          </h1>

          <div className="row">
            <div className="col-xl-10">
              <Panel>
                <PanelHeader>Add Label</PanelHeader>
                <PanelBody className="panel-form">
                  <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
                    {this.renderInput("printerName", "Printer Name", "text", "Enter Name of Printer")}
                    {this.renderInput("name", "Label Name", "text", "* Enter Name for label")}
                    {this.renderInput("description", "Description", "text", "Fill in description for label")}
                    {this.renderInput("fontSize", "Font Size", "text", "Enter Size for font (e.g., 12pt)")}


                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">  Label Size</label>
                      <div className="col-lg-8">
                        <select name="labelSize" id="labelSize" value={this.state.data.labelSize || ""}
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Label size</option>
                          {this.labelSizeoptions}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">  Barcode Type</label>
                      <div className="col-lg-8">
                        <select name="barcodeType" id="barcodeType" value={this.state.data.barcodeType || ""}
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Barcode Type</option>
                          {this.barcodeTypeoptions}
                        </select>
                      </div>
                    </div>


                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Print Quality</label>
                      <div className="col-lg-8">
                        <select name="printQuality" id="printQuality" value={this.state.data.printQuality || ""}
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Print Quality</option>
                          {this.printQualityOptions}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Print Density</label>
                      <div className="col-lg-8">
                        <select name="printDensity" id="printDensity" value={this.state.data.printDensity || ""}
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Print Density</option>
                          {this.printDensityOptions}
                        </select>
                      </div>
                    </div>


                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Orientation</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="orientation" value={true} onChange={this.handleBoolean} checked={data.orientation === true} />
                            <label className="form-check-label" htmlFor="orientation">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="orientation" value={false} onChange={this.handleBoolean} checked={data.orientation === false} />
                            <label className="form-check-label" htmlFor="orientation">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">SKU</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="SKU" value={true} onChange={this.handleBoolean} checked={data.SKU === true} />
                            <label className="form-check-label" htmlFor="SKU">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="SKU" value={false} onChange={this.handleBoolean} checked={data.SKU === false} />
                            <label className="form-check-label" htmlFor="SKU">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Serial</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="serial" value={true} onChange={this.handleBoolean} checked={data.serial === true} />
                            <label className="form-check-label" htmlFor="serial">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="serial" value={false} onChange={this.handleBoolean} checked={data.serial === false} />
                            <label className="form-check-label" htmlFor="serial">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Made In</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="madeIn" value={true} onChange={this.handleBoolean} checked={data.madeIn === true} />
                            <label className="form-check-label" htmlFor="madeIn">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="madeIn" value={false} onChange={this.handleBoolean} checked={data.madeIn === false} />
                            <label className="form-check-label" htmlFor="madeIn">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Print Username</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="printUsername" value={true} onChange={this.handleBoolean} checked={data.printUsername === true} />
                            <label className="form-check-label" htmlFor="printUsername">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="printUsername" value={false} onChange={this.handleBoolean} checked={data.printUsername === false} />
                            <label className="form-check-label" htmlFor="printUsername">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Printed On</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="printedOn" value={true} onChange={this.handleBoolean} checked={data.printedOn === true} />
                            <label className="form-check-label" htmlFor="printedOn">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="printedOn" value={false} onChange={this.handleBoolean} checked={data.printedOn === false} />
                            <label className="form-check-label" htmlFor="printedOn">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">AWB</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="AWB" value={true} onChange={this.handleBoolean} checked={data.AWB === true} />
                            <label className="form-check-label" htmlFor="AWB">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="AWB" value={false} onChange={this.handleBoolean} checked={data.AWB === false} />
                            <label className="form-check-label" htmlFor="AWB">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Expired On</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="expiredOn" value={true} onChange={this.handleBoolean} checked={data.expiredOn === true} />
                            <label className="form-check-label" htmlFor="expiredOn">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="expiredOn" value={false} onChange={this.handleBoolean} checked={data.expiredOn === false} />
                            <label className="form-check-label" htmlFor="expiredOn">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Country</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="country" value={true} onChange={this.handleBoolean} checked={data.country === true} />
                            <label className="form-check-label" htmlFor="country">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="country" value={false} onChange={this.handleBoolean} checked={data.country === false} />
                            <label className="form-check-label" htmlFor="country">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Delivery</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="delivery" value={true} onChange={this.handleBoolean} checked={data.delivery === true} />
                            <label className="form-check-label" htmlFor="delivery">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="delivery" value={false} onChange={this.handleBoolean} checked={data.delivery === false} />
                            <label className="form-check-label" htmlFor="delivery">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Location</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="location" value={true} onChange={this.handleBoolean} checked={data.location === true} />
                            <label className="form-check-label" htmlFor="location">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="location" value={false} onChange={this.handleBoolean} checked={data.location === false} />
                            <label className="form-check-label" htmlFor="location">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label">Note</label>
                      <div className="col-lg-8">
                        <div className="row row-space-5">
                          <div className="form-check mr-4">
                            <input className="form-check-input" type="radio" name="note" value={true} onChange={this.handleBoolean} checked={data.note === true} />
                            <label className="form-check-label" htmlFor="note">Yes</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="radio" name="note" value={false} onChange={this.handleBoolean} checked={data.note === false} />
                            <label className="form-check-label" htmlFor="note">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.renderInput("copies", "Copies", "number", "Enter number of copies")}

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="serviceImage">Service Images</label>
                      <div className="col-lg-8">
                        <div className="row row-space-10">
                          <input type="file" id="serviceImage" name="serviceImage" className="form-control-file m-b-5" onChange={this.onChangeImgHandler} multiple />
                          {errors.serviceImage && (
                            <div className="alert alert-danger">
                              {errors.serviceImage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-lg-8">
                        <button type="submit" disabled={this.validate() || this.state.loading} className="btn btn-primary btn-sm" >
                          {this.state.loading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Label);
